import { FormFieldSchema } from "@app/components/forms/types/schema";

export const schemaToJson = (
  schema: FormFieldSchema[],
): Record<string, any> => {
  let values: any = {};
  schema.forEach((field) => {
    if (field.type === "separator") return;
    if (field.type === "group") {
      const json = schemaToJson(field.schemas);
      Object.assign(values, json);
      return;
    }
    values[field.id] = field.defaultValue ?? "";
  });
  return values;
};
